(function () {
  var formId = window.klaviyoFormId;
  if (!formId) return;

  var SESSION_KEY = 'klaviyoDesktopAutoOpenAttempted';
  var attempted = false;

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function alreadyAttemptedThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markAttempted() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      // sessionStorage unavailable (e.g. private mode) - fall back to the
      // in-memory `attempted` flag for this page load only.
    }
  }

  function tryAutoOpen() {
    if (attempted || alreadyAttemptedThisSession()) return;
    if (!isDesktop()) return;
    if (!window.klaviyoMarketingConsentGranted || !window.klaviyoMarketingConsentGranted()) return;

    attempted = true;
    markAttempted();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  tryAutoOpen();

  // MPCF dispatches these when consent changes without a page reload.
  document.addEventListener('truyoCookieSettingsUpdateEvent', tryAutoOpen);
  document.addEventListener('visitorConsentCollected', tryAutoOpen);
})();
